<template>
  <div @mousewheel.stop>
    <!-- swiper1 -->
    <swiper :options="swiperOption" class="gallery-thumbs" ref="articleSwiper1">
      <swiper-slide>1</swiper-slide>
      <swiper-slide>2</swiper-slide>
      <swiper-slide>3</swiper-slide>
      <swiper-slide>4</swiper-slide>
      <swiper-slide>5</swiper-slide>
    </swiper>
    <!-- swiper2 Thumbs -->
    <swiper :options="swiperOption" class="gallery-thumbs" ref="articleSwiper2">
      <swiper-slide>11</swiper-slide>
      <swiper-slide>22</swiper-slide>
      <swiper-slide>33</swiper-slide>
      <swiper-slide>44</swiper-slide>
      <swiper-slide>55</swiper-slide>
    </swiper>
  </div>
</template>
<script>
export default {
  data () {
    return {
      swiperOption: {
        direction: 'vertical',
        nested: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        mousewheel: true,
        centeredSlides: true,
        resistanceRatio: 0,
        loop: true
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const articleSwiper1 = this.$refs.articleSwiper1.swiper
      const articleSwiper2 = this.$refs.articleSwiper2.swiper
      articleSwiper1.controller.control = articleSwiper2
      articleSwiper2.controller.control = articleSwiper1
    })
  }
}
</script>

<style lang="stylus" scoped>
.swiper-container {
  background-color: #000;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
  width 40px
  height 50px
  background: red
  border 1px solid #fff
  &.slide-1 {
    background-image: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532435333950&di=1815a96785f9604470ee5aafbd89f295&imgtype=0&src=http%3A%2F%2Fattach.bbs.miui.com%2Fforum%2F201507%2F01%2F101024hpo6hqhvt77dhsqq.jpg');
  }
  &.slide-2 {
    background-image: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532435333950&di=1815a96785f9604470ee5aafbd89f295&imgtype=0&src=http%3A%2F%2Fattach.bbs.miui.com%2Fforum%2F201507%2F01%2F101024hpo6hqhvt77dhsqq.jpg');
  }
  &.slide-3 {
    background-image: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532435333950&di=1815a96785f9604470ee5aafbd89f295&imgtype=0&src=http%3A%2F%2Fattach.bbs.miui.com%2Fforum%2F201507%2F01%2F101024hpo6hqhvt77dhsqq.jpg');
  }
  &.slide-4 {
    background-image: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532435333950&di=1815a96785f9604470ee5aafbd89f295&imgtype=0&src=http%3A%2F%2Fattach.bbs.miui.com%2Fforum%2F201507%2F01%2F101024hpo6hqhvt77dhsqq.jpg');
  }
  &.slide-5 {
    background-image: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532435333950&di=1815a96785f9604470ee5aafbd89f295&imgtype=0&src=http%3A%2F%2Fattach.bbs.miui.com%2Fforum%2F201507%2F01%2F101024hpo6hqhvt77dhsqq.jpg');
  }
}

.gallery-top {
  height: 80% !important;
  width: 100%;
}

.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/TestCom.vue